export type OAuthProvider = "google" | "naver";

export type OAuthProviders = Record<OAuthProvider, boolean>;

export type OAuthProviderState =
  | { status: "loading"; providers: OAuthProviders }
  | { status: "ready"; providers: OAuthProviders }
  | { status: "error"; providers: OAuthProviders };

const unavailableProviders: OAuthProviders = { google: false, naver: false };

export const loadingOAuthProviders = (): OAuthProviderState => ({
  status: "loading",
  providers: { ...unavailableProviders },
});

export async function resolveOAuthProviders(
  load: () => Promise<OAuthProviders>,
): Promise<OAuthProviderState> {
  try {
    return { status: "ready", providers: await load() };
  } catch {
    return { status: "error", providers: { ...unavailableProviders } };
  }
}

export function oauthProviderSurface(state: OAuthProviderState): {
  available: OAuthProvider[];
  notice: string | null;
  retry: boolean;
} {
  if (state.status === "loading") {
    return {
      available: [],
      notice:
        "소셜 로그인 사용 가능 여부를 확인하고 있어요. 이메일로는 바로 시작할 수 있어요.",
      retry: false,
    };
  }
  if (state.status === "error") {
    return {
      available: [],
      notice:
        "소셜 로그인 상태를 확인하지 못했어요. 이메일 로그인은 그대로 사용할 수 있어요.",
      retry: true,
    };
  }
  const available = (Object.keys(state.providers) as OAuthProvider[]).filter(
    (provider) => state.providers[provider],
  );
  return {
    available,
    notice:
      available.length === 0
        ? "지금은 이메일로 가입하거나 로그인할 수 있어요."
        : null,
    retry: false,
  };
}
